import { Input } from '@progress/kendo-react-inputs';
import Dialog from '@mui/material/Dialog';
import { Form, Field, FormElement, FormRenderProps } from '@progress/kendo-react-form';
import { DialogTitle } from '@mui/material';

interface ConfirmDeleteProps {
  cancelEdit: () => void;
  onSubmit: (event) => void;
  isOpen: boolean;
  item: any;
  title: string;
  confirmText: string;
  confirmField?: string;
  maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const ConfirmDelete = (props: ConfirmDeleteProps) => {
  let confirmValue: string = props.item[props.confirmField];

  const namesMatch = (confirmField: string) => (confirmField === confirmValue ? '' : 'does not match');

  return (
    <Dialog maxWidth={props.maxWidth || 'xs'} fullWidth open={props.isOpen} onClose={props.cancelEdit}>
      <DialogTitle>{props.title} </DialogTitle>
      <Form
        onSubmit={props.onSubmit}
        initialValues={props.item}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement style={{ paddingLeft: '20px', paddingRight: '20px', paddingBottom: '20px' }}>
            <p>{props.confirmText}</p>

            {props.confirmField && (
              <>
                <p>
                  Please retype <b>{confirmValue}</b> to confirm
                </p>

                <fieldset className={'k-form-fieldset label-bold'}>
                  <div className="mb-3">
                    <Field name={'confirmItem'} component={Input} validator={namesMatch} />
                  </div>
                </fieldset>
              </>
            )}
            <div className="k-form-buttons pad-top-5">
              <button
                style={{ color: 'var(--palette-error-main)', fontWeight: 'bold' }}
                type={'submit'}
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                disabled={props.confirmField && (!formRenderProps.allowSubmit || !formRenderProps.touched)}
              >
                Delete
              </button>
              <button type={'submit'} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={props.cancelEdit}>
                Cancel
              </button>
            </div>
          </FormElement>
        )}
      />
    </Dialog>
  );
};
export default ConfirmDelete;
